import type {CompleteMeshData} from "#template/interfaces/mesh-data"
import type {CompleteCurveData} from "#template/interfaces/curve-data"
import type {ObjectId, ObjectPath, SceneNodes} from "#template/interfaces/scene-object"
import type {SolverData} from "#template/runtime-graph/nodes/solver/data"
import type {SolverObjectData} from "#template/runtime-graph/nodes/solver/object-data"
import type {Matrix4, Vector3} from "@cm/math"
import type {ObjectBounds} from "#template/geometry-processing/bounds"

export interface ObjectData {
    type?: string
    id: ObjectId
    path: ObjectPath
    bounds?: ObjectBounds
    dimensionGuideBounds?: ObjectBounds
    solverObject: SolverObjectData
    matrix: Matrix4
    preDisplayList: SceneNodes.SceneNode[]
    displayList: SceneNodes.SceneNode[]
    solverData: SolverData
    visible: boolean
}
export type MeshData = {
    type: "mesh"
    completeMeshData: CompleteMeshData
    isProcedural: boolean
    visibleDirectly: boolean
    visibleInReflections: boolean
    visibleInRefractions: boolean
    receiveRealtimeShadows: boolean
    castRealtimeShadows: boolean
}

export type MeshObjectData = ObjectData & MeshData

export function isMeshObjectData(objectData: ObjectData): objectData is MeshObjectData {
    return objectData.type === "mesh"
}

export type ControlPoint = {position: Vector3; normal: Vector3; corner: boolean; sectionBreak: boolean}

export type CurvePoints = Omit<NonNullable<CompleteCurveData["reified"]>, "contentHash">

export type CurveData = {
    type: "curve"
    visible: boolean
    controlPoints: ControlPoint[]
    closed: boolean
    completeCurveData: CompleteCurveData
    matrix: Matrix4
}

export type CurveObjectData = ObjectData & CurveData

export function isCurveObjectData(objectData: ObjectData): objectData is CurveObjectData {
    return objectData.type === "curve"
}
